import { useCallback } from 'react';
import { useForm } from 'react-final-form';

import { useRegistrationContext } from '@interlayer/js/app/components/main/Registration/hocs/context';
import { useGtmEventReg } from '@interlayer/js/app/components/main/Registration/hooks/useGtmEventReg';

export const useRegistrationValidationEvent = ({ fieldName }: { fieldName: string }) => {
    const form = useForm();
    const gtmEventReg = useGtmEventReg();
    const { isRegistration } = useRegistrationContext();

    return useCallback(() => {
        if (!isRegistration) {
            return;
        }

        const field = form.getFieldState(fieldName);

        gtmEventReg(field?.valid ? 'formValidationSuccess' : 'formValidationError', {
            field: field?.name || 'unknown'
        });
    }, [fieldName, form, gtmEventReg, isRegistration]);
};
